import { Router as BrowserRouter } from 'react-router-dom'
import { browserHistory } from '~/shared/lib/browser-history'

export const withRouter = (component: () => JSX.Element) => () => {
  return <BrowserRouter history={browserHistory}>{component()}</BrowserRouter>
}
